module.exports = __webpack_public_path__ + "static/screen2-0b35f552903190e84a3f59a969785022.png";